import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getSubcontractorById,
  updateSubcontractor,
} from '../../../../services/SubcontractorService';

const UpdateSubcontractor = () => {
  const [program, setProgram] = useState('');
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [pocname, setPocName] = useState('');
  const [pocemail, setPocEmail] = useState('');
  const [pocphone, setPocPhone] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubcontractor = async () => {
      try {
        const subcontractor = await getSubcontractorById(id);
        setProgram(subcontractor.program || '');
        setName(subcontractor.name || '');
        setNumber(subcontractor.number || '');
        setPocName(subcontractor.pocname || '');
        setPocEmail(subcontractor.pocemail || '');
        setPocPhone(subcontractor.pocphone || 'NA');
      } catch (error) {
        console.error('Error fetching subcontractor details', error);
      }
    };

    fetchSubcontractor();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateSubcontractor(id, {
        program,
        name,
        number,
        pocname,
        pocemail,
        pocphone,
      });
      navigate('/settings/subcontractor/');
    } catch (error) {
      console.error('Error updating subcontractor', error);
    }
  };

  return (
    <div>
      <Card className="p-3">
        <h2>Update Subcontractor</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group controlId="program" className="mb-3">
                <Form.Label>Program</Form.Label>
                <Form.Control
                  type="text"
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="name" className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="number" className="mb-3">
                <Form.Label>Subcontract Number</Form.Label>
                <Form.Control
                  type="text"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="pocname" className="mb-3">
                <Form.Label>POC Name</Form.Label>
                <Form.Control
                  type="text"
                  value={pocname}
                  onChange={(e) => setPocName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group controlId="pocemail" className="mb-3">
                <Form.Label>POC Email</Form.Label>
                <Form.Control
                  type="email"
                  value={pocemail}
                  onChange={(e) => setPocEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="pocphone" className="mb-3">
                <Form.Label>POC Phone</Form.Label>
                <Form.Control
                  type="text"
                  value={pocphone}
                  onChange={(e) => setPocPhone(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end">
            <Button type="submit" variant="primary">
              Update Subcontractor
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default UpdateSubcontractor;
